import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  fetchTermsCondition,
  fetchTermsConditions,
} from "services/termsCondition";

const TermsConditionDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  setTermsConditionDetails,
}) => {
  const VendorName = getValues().zone_type;
  const selectedTermsConditionId = watch("terms_and_condition_id");
  const login = useSelector((state) => state.jwtAuthreducer);

  const auth = useSelector((state) => state.jwtAuthreducer);
  const { employee_code_id } = auth?.user;

  const [zoneId, setZoneId] = useState(localStorage.getItem("zone_id") || null);

  const {
    data: termsCondition,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(["fetch-terms-condition"], () => fetchTermsConditions(), {
    staleTime: DROPDOWN_STALE_TIME,
  });

  const { data: termsConditionData } = useQuery(
    ["fetch-terms-by-id", selectedTermsConditionId],
    () =>
      selectedTermsConditionId
        ? fetchTermsCondition(selectedTermsConditionId)
        : null,
    { staleTime: DROPDOWN_STALE_TIME, enabled: !!selectedTermsConditionId }
  );

  setTermsConditionDetails(termsConditionData?.data);

  useEffect(() => {
    refetch();
  }, [login]);

  const options = useMemo(
    () =>
      termsCondition?.data?.data?.map((vendor) => ({
        value: vendor?.id,
        label: vendor?.title,
      })) || [],
    [termsCondition]
  );

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.terms_and_condition_id
      );
      setValue("terms_and_condition_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedTermsConditionId || VendorName
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading zones</div>;

  console.log("selectedTermsConditionId", selectedTermsConditionId);

  return (
    <>
      <Controller
        name="terms_and_condition_id"
        control={control}
        rules={{
          required: required ? "Terms condition is required" : false,
          validate: (value) => {
            if (required && !value) return "Terms condition is required";
            return true;
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            isClearable
            placeholder="Select Terms And Condition"
            value={selectedOption || null}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                height: "42px",
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
              }),
            }}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              field.onChange(value);
              setValue("terms_and_condition_id", value);
            }}
            className={`react-select-container ${
              errors.terms_and_condition_id ? "is-invalid" : ""
            }`}
          />
        )}
      />
    </>
  );
};

export default TermsConditionDropDown;
